import { render, staticRenderFns } from "./picViewRecycle.vue?vue&type=template&id=a496eb1e&scoped=true&"
import script from "./picViewRecycle.vue?vue&type=script&lang=js&"
export * from "./picViewRecycle.vue?vue&type=script&lang=js&"
import style0 from "./picViewRecycle.vue?vue&type=style&index=0&id=a496eb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a496eb1e",
  null
  
)

export default component.exports